export const searchToggle = function (el) {
    const searchEnabler = el.querySelector(".search");
    searchEnabler.addEventListener("click", function () {
        if (el.classList.contains("search-enabled")) {
            el.classList.remove("search-enabled");
            document.body.classList.remove("search-enabled");
        } else {
            el.classList.add("search-enabled");
            document.body.classList.add("search-enabled");
            document.querySelector(".topbar__search-field").focus();
        }
    });
};

export const search = function (el) {
    el.querySelector(".topbar__search-field").addEventListener("keyup", function (evt) {
        if (evt.keyCode == 13) {
            const query = document.querySelector(".topbar__search-field").value;
            document.location.href = '/?s='+encodeURIComponent(query);
        }
    })
};
